import { bBillingTypeTableDirective } from './bBillingTypeTable/bBillingTypeTable.directive';

export default angular.module('frontend.adminCountryTables', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('bBillingTypeTable', bBillingTypeTableDirective);